import { render, staticRenderFns } from "./DataLoader.vue?vue&type=template&id=bfd58d02&"
import script from "./DataLoader.vue?vue&type=script&lang=js&"
export * from "./DataLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports